<template>
    <button
        type="button"
        class="more-market-toggle"
        v-bind:class="{ _live: isLive }"
        v-bind:aria-expanded="isExpanded"
        v-on:click="emit('update:isExpanded', !isExpanded)"
    >
        <span class="more-market-toggle-count">{{ count }}</span>
        <span>{{ i18n.t(isExpanded ? 'cta_show_less' : 'cta_show_more') }}</span>
        <SboIcon
            name="system:arrowDown"
            v-bind:size="14"
            v-bind:rotated="isExpanded"
            class="more-market-toggle-icon"
        />
    </button>
</template>

<script lang="ts" setup>
    import SboIcon from '@/components/common/SboIcon.vue';
    import { i18n } from '@/libraries/i18n';

    defineProps({
        count: {
            type: Number,
            required: true,
        },
        isExpanded: {
            type: Boolean,
            default: false,
        },
        isLive: {
            type: Boolean,
            default: false,
        },
    });

    const emit = defineEmits<{
        'update:isExpanded': [value: boolean];
    }>();
</script>

<style lang="scss" scoped>
@import "@/scss/components/moreMarketToggle";
</style>
